export const MULTI_FILTER_NULL_VALUE = '<<null>>';
